const upgradeCopySlug = value => String(value)
  .normalize('NFKD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '_')
  .replace(/^_+|_+$/g, '');

const localizeCopy = (value, translate) =>
  typeof value === 'string'
    ? translate(`upgrade_page.copy.${upgradeCopySlug(value)}`, value)
    : value;

export const localizeUpgradeContent = (content, translate) => {
  if (!content) return content;
  const localized = {...content};
  for (const field of ['eyebrow', 'title', 'description', 'beforeLabel', 'afterLabel', 'afterTitle', 'more', 'intro']) {
    if (typeof localized[field] === 'string') localized[field] = localizeCopy(localized[field], translate);
  }
  if (typeof localized.minimumPlan === 'string' && !['Starter', 'Growth', 'Scale'].includes(localized.minimumPlan)) {
    localized.minimumPlan = localizeCopy(localized.minimumPlan, translate);
  }
  for (const field of ['beforeItems', 'afterOptions']) {
    if (Array.isArray(localized[field])) localized[field] = localized[field].map(value => localizeCopy(value, translate));
  }
  if (Array.isArray(localized.plans)) {
    localized.plans = localized.plans.map(plan => ({
      ...plan,
      label: localizeCopy(plan.label, translate),
      description: localizeCopy(plan.description, translate),
      benefits: Array.isArray(plan.benefits) ? plan.benefits.map(value => localizeCopy(value, translate)) : plan.benefits,
    }));
  }
  return localized;
};
